import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';
import numericInput from '../../../../../lib/numericInput';

import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const wattOptions = range(10, 160, 10).map(value => ({
  value,
  display: numericInput.format(value),
}));

const TurnOffLights = ({
  t,
  widgetSource,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I will turn off')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_turn_off_lights_number'}
        />
        {t('lights with an average of')}
        <InlineSelect
          options={wattOptions}
          apiKey={'input_takeaction_turn_off_lights_watts'}
        />
        {t('watts for')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_turn_off_lights_hours'}
        />
        {t('hours a day.')}
      </p>
    </div>
    {widgetSource !== 'ontario' && <div className="action-details__links">
      <a
        href="http://www.coolcalifornia.org/funding-wizard#search//%255BZipcode%253D%253D94720%255D%255BEligible+Applicants%253D%253DIndividual%255D%255BCategory%253D%253DEnergy%255D/false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>
    </div>}
  </div>
);

TurnOffLights.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [].reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('turnOffLights'),
  connect(mapStateToProps, mapDispatchToProps)(TurnOffLights),
);
